import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { createJobAction } from "../redux/actions/jobAction";
import { useNavigate } from "react-router-dom";

import { countries } from "../data/countries";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Image from "../images/hero_1.jpg";

import { userSignInAction } from "../redux/actions/userAction";

const validationSchema = yup.object({
  company: yup.string().min(3).required("company name is required."),
  tagline: yup.string().min(3).required("tagline is required"),
  companyLocation: yup
    .string()
    .min(3)
    .required("company Location is required."),
  companyDescription: yup
    .string()
    .min(15)
    .required("enter at leat 15 characters"),
});

const CreateCompany = () => {
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      company: "",
      tagline: "",
      companyLocation: "",
      companyDescription: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      console.log(values);
      // dispatch(createJobAction(values));
      //actions.resetForm();
    },
  });

  const [content, setContent] = useState("");
  const handleQuillChange = (value) => {
    setContent(value);
    const strippedValue = value.replace(/^<p>(.*?)<\/p>$/, "$1");
    formik.setFieldValue("companyDescription", strippedValue);
  };
  return (
    <>
      <section
        className="section-hero overlay inner-page bg-image"
        id="home-section"
        style={{
          backgroundImage: `url(${Image})`,
        }}
      >
        <div class="container">
          <div class="row">
            <div class="col-md-7">
              <h1 class="text-white font-weight-bold">Create A Company</h1>
              <div class="custom-breadcrumbs">
                <a href="/">Home</a> <span class="mx-2 slash">/</span>
                <a href="/jobSingle">Company</a>{" "}
                <span class="mx-2 slash">/</span>
                <span class="text-white">
                  <strong>Create a Company</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="site-section">
        <div class="container border-1">
          <div class="row mb-1">
            <div class="col-lg-12">
              <form onSubmit={formik.handleSubmit}>
                <h3 class="text-black my-5 border-bottom pb-2">
                  Company Details
                </h3>
                <div class="form-group">
                  <label for="company-name">Company Name</label>
                  <input
                    type="text"
                    class="form-control"
                    id="company-name"
                    name="company"
                    placeholder="e.g. Meta"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.company}
                    style={{
                      borderColor:
                        formik.errors.company && formik.touched.company
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.company && formik.touched.company
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.company && formik.touched.company && (
                    <p style={{ color: "red" }}>{formik.errors.company}</p>
                  )}
                </div>

                <div class="form-group">
                  <label for="company-tagline">Tagline (Optional)</label>
                  <input
                    type="text"
                    class="form-control"
                    id="company-tagline"
                    name="tagline"
                    placeholder="e.g. For a better future with innovations"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.tagline}
                    style={{
                      borderColor:
                        formik.errors.tagline && formik.touched.tagline
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.tagline && formik.touched.tagline
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.tagline && formik.touched.tagline && (
                    <p style={{ color: "red" }}>{formik.errors.tagline}</p>
                  )}
                </div>
                <div class="form-group">
                  <label for="company-tagline">Location</label>
                  <input
                    type="text"
                    class="form-control"
                    id="company-tagline"
                    name="companyLocation"
                    placeholder="e.g. New York"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.companyLocation}
                    style={{
                      borderColor:
                        formik.errors.companyLocation &&
                        formik.touched.companyLocation
                          ? "red"
                          : "",
                      backgroundColor:
                        formik.errors.companyLocation &&
                        formik.touched.companyLocation
                          ? "#fce7f3"
                          : "",
                    }}
                  />
                  {formik.errors.companyLocation &&
                    formik.touched.companyLocation && (
                      <p style={{ color: "red" }}>
                        {formik.errors.companyLocation}
                      </p>
                    )}
                </div>

                <div class="form-group">
                  <label for="job-description">Company Description</label>
                  <div class="editor" id="editor-2">
                    <ReactQuill
                      theme="snow"
                      name="companyDescription"
                      value={content}
                      onChange={handleQuillChange}
                      style={{ height: "300px" }}
                    />{" "}
                    {formik.errors.companyDescription &&
                      formik.touched.companyDescription && (
                        <p style={{ color: "red" }}>
                          {formik.errors.companyDescription}
                        </p>
                      )}
                  </div>
                </div>
                <div class="form-group">
                  <label for="company-website-tw d-block">Upload Logo</label>{" "}
                  <br />
                  <label class="btn btn-primary btn-md btn-file">
                    Browse File
                    <input type="file" hidden />
                  </label>
                </div>
                <div class="row align-items-center mb-5">
                  <div class="col-lg-4 ml-auto">
                    <div class="row">
                      <div class="col-6"></div>
                      <div class="col-6">
                        <button
                          class="btn btn-block btn-primary btn-md"
                          type="submit"
                        >
                          Save Company
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CreateCompany;
